import { render, staticRenderFns } from "./grid-form-item.vue?vue&type=template&id=b7157fa0"
import script from "./grid-form-item.vue?vue&type=script&lang=js"
export * from "./grid-form-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports